<template>
	<router-view></router-view>
</template>
<script>
export default { name: 'RouterViewWrapper' };
</script>
<style scoped lang="scss"></style>
